import axios from './common';

const state = {
    levels: [],
    levelsQueryParams: {
        description: null,
        limit: 10,
        page: 1,
    },
    currentLevelItem: null,
    editableLevelItem: null,
    levelsLoading: false,
    levelItemLoading: false,
    levelApiError: null,
    totalLevels: 0,
};

const getters = {
    levels: state => {
        return state.levels;
    },
    levelsQueryParams: state => {
        return state.levelsQueryParams;
    },
    levelsLoading: state => {
        return state.levelsLoading;
    },
    currentLevelItem: state => {
        return state.currentLevelItem;
    },
    editableLevelItem: state => {
        return state.editableLevelItem;
    },
    levelItemLoading: state => {
        return state.levelItemLoading;
    },
    levelApiError: state => {
        return state.levelApiError;
    },
    totalLevels: state => {
        return state.totalLevels;
    },
};

const actions = {
    getLevels(context) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: 'Loading Levels',
        }, {root: true}).then(() => context.commit('setLevelsLoading', true));

        axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/levels/`, {
            params: context.state.levelsQueryParams,
        })
            .then(response => {
                context.dispatch('addNotification', {
                    status: 'success',
                    message: 'Levels successfully loaded',
                }, {root: true}).then(function() {
                    context.commit('setLevelsLoading', false);
                    context.commit('setLevels', response.data);
                });
            });
    },
    async deleteLevel(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Deleting Level "${item.name}"`,
        }, {root: true}).then(() => context.commit('setLevelItemLoading', true));

        try {
            await axios.delete(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/levels/${item._id}`);
            await context.dispatch('addNotification', {
                status: 'success',
                message: `Successfully deleted Level "${item.name}"`,
            }, {root: true});
            return true;
        } catch(error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Level "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Delete failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('setLevelApiError', error);
                    console.error('levelApiError', error);
                });
            }
            return false;
        } finally {
            context.commit('setLevelItemLoading', false);
            await context.dispatch('clearLevelItems');
            await context.dispatch('getLevels');
        }
    },
    async getLevel(context, item) {
        context.dispatch('addNotification', {
            status: 'loading',
            message: `Retrieving Level "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setLevelItemLoading', true);
            context.commit('setLevelApiError', null);
        });

        try {
            const response = await axios.get(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/levels/${item._id}`);
            context.commit('setCurrentLevelItem', response.data);
        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Level "${item.name}" was deleted and no longer exists`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Retrieval failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    console.error('levelApiError', error);
                });
            }
        } finally {
            context.commit('setLevelItemLoading', false);
        }
    },
    async editLevel(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Editing Level "${item.name}"`,
        }, {root: true}).then(function() {
            context.commit('setLevelItemLoading', true);
            context.commit('setLevelApiError', null);
        });

        try {
            await axios.put(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/levels/${item._id}`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Level "${item.name}" successfully edited`,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response && error.response.status === 404) {
                await context.dispatch('addNotification', {
                    status: 'error',
                    message: `Level "${item.name}" was deleted and no longer existsn`,
                }, {root: true});
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Edit failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    // client received an error response (5xx, 4xx) or no response at all
                    context.commit('levelApiError', error);
                    console.error('levelApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setLevelItemLoading', false);
            await context.dispatch('clearLevelItems');
            await context.dispatch('getLevels');
        }
    },
    async addLevel(context, item) {

        context.dispatch('addNotification', {
            status: 'loading',
            message: `Adding Level "${item.name}"`,
        }, {root: true}).then(function () {
            context.commit('setLevelItemLoading', true);
            context.commit('setLevelApiError', null);
        });

        try {

            await axios.post(`${process.env.VUE_APP_SERVICE_URI_COURSE}/api/levels/`, item);

            await context.dispatch('addNotification', {
                status: 'success',
                message: `Level "${item.name}" successfully added`,
            }, {root: true});

            return true;

        } catch (error) {
            if (error.response) {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Failed to add Level "${item.name}", please try again`,
                }, {root: true}).then(() => {
                    context.commit('setLevelApiError', error.response.data);
                });
            } else {
                context.dispatch('addNotification', {
                    status: 'error',
                    message: `Add failed. An unknown error occurred`,
                }, {root: true}).then(() => {
                    context.commit('setLevelApiError', error);
                    console.error('levelApiError', error);
                });
            }

            return false;
        } finally {
            context.commit('setLevelItemLoading', false);
            await context.dispatch('getLevels');
        }
    },
    clearLevelItems(context) {
        context.commit('setCurrentLevelItem', null);
        context.commit('setEditableLevelItem', null);
    },
    clearLevelApiError(context) {
        context.commit('setLevelApiError', null);
    },
    setLevelPaginationOptions(context, options) {
        context.commit('levelPaginationOptions', options);
    },
    setLevelsSearch(context, search) {
        context.commit('levelsSearch', search);
    },
};

const mutations = {
    levelPaginationOptions(state, options) {
        state.levelsQueryParams.limit = options.itemsPerPage ?? 10;
        state.levelsQueryParams.page = options.page ?? 1;
    },
    levelsSearch(state, search) {
        state.levelsQueryParams.description = `/${search.trim()}/i`;
    },
    setLevels(state, responseData) {
        state.levels = responseData.docs;
        state.totalLevels = responseData.totalDocs;
    },
    setCurrentLevelItem(state, item) {
        state.currentLevelItem = item;
        state.editableLevelItem = {...item};
    },
    setEditableLevelItem(state, item) {
        state.editableLevelItem = item;
    },
    setLevelItemLoading(state, isLoading) {
        state.levelItemLoading = isLoading;
    },
    setLevelsLoading(state, isLoading) {
        state.levelsLoading = isLoading;
    },
    setLevelApiError(state, error) {
        state.levelApiError = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};